import { ApprovalFiltersI } from "../../providers/approvals/types";
import { Fetch } from "../../utils/fetch";
import { getQueryParamsString } from "../../utils/parseData";
import { DedicatedOfferModelI,
  SingleOfferModelI,
  UpdateDedicatedOfferModelI,
  UpdateSingleOfferModelI } from "./approvalsTypes";
import { routes } from "./routes";

class ApprovalService {
  createDedicatedOffer(payload: DedicatedOfferModelI) {
    return Fetch("post", routes.createDedicatedOffer, payload);
  }

  createSingleOffer(payload: SingleOfferModelI) {
    return Fetch("post", routes.createSingleOffer, payload);
  }

  updateOfferQueue(payload: UpdateSingleOfferModelI | UpdateDedicatedOfferModelI) {
    return Fetch("patch", routes.updateOfferQueue(payload.approval_id), payload);
  }

  getApprovalsQueue(payload: ApprovalFiltersI) {
    const route = getQueryParamsString(payload, routes.getApprovalsQueue);

    return Fetch("get", route);
  }

  getOrders() {
    return Fetch("get", routes.getOrders);
  }

  getUsers() {
    return Fetch("get", routes.getUsers);
  }

  getLocations() {
    return Fetch("get", routes.getLocations);
  }

  getEquipmentTypes() {
    return Fetch("get", routes.getEquipmentTypes);
  }

  getCarriers() {
    return Fetch("get", routes.getCarriers);
  }

  deleteApprovalQueue(payload: any) {
    const { approval_id } = payload;

    return Fetch("delete", routes.deleteApprovalQueue(approval_id), payload);
  }

  updateStatusQueue(payload: any, approval_id: number) {
    return Fetch("put", routes.updateStatusQueue(approval_id), payload);
  }

  getApprovalsHistory(payload: ApprovalFiltersI) {
    const route = getQueryParamsString(payload, routes.getApprovalsHistory);

    return Fetch("get", route);
  }
}

export default new ApprovalService();
